<template>
  <svg
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconIncomingArrow">
      <path
        id="Vector"
        d="M1.60854 1.42912C1.51738 1.34417 1.39681 1.29793 1.27222 1.30012C1.14763 1.30232 1.02877 1.35279 0.940657 1.4409C0.852548 1.52901 0.802078 1.64788 0.79988 1.77246C0.797681 1.89705 0.843927 2.01763 0.928873 2.10879L5.55833 6.73825H1.90991C1.78237 6.73825 1.66005 6.78891 1.56986 6.8791C1.47967 6.96929 1.42901 7.0916 1.42901 7.21915C1.42901 7.34669 1.47967 7.46901 1.56986 7.55919C1.66005 7.64938 1.78237 7.70005 1.90991 7.70005H6.7189C6.78213 7.7003 6.84477 7.68804 6.90323 7.66396C6.96169 7.63988 7.01481 7.60447 7.05952 7.55976C7.10422 7.51505 7.13964 7.46194 7.16371 7.40348C7.18779 7.34502 7.20006 7.28237 7.1998 7.21915V2.41015C7.1998 2.28261 7.14914 2.16029 7.05895 2.0701C6.96876 1.97992 6.84644 1.92925 6.7189 1.92925C6.59136 1.92925 6.46904 1.97992 6.37885 2.0701C6.28867 2.16029 6.238 2.28261 6.238 2.41015V6.05858L1.60854 1.42912Z"
        fill="#434343"
      />
    </g>
  </svg>
</template>
